// Footer Links
export const footerLinks = {
  company: [
    { name: 'About Us', href: '#about' },
    { name: 'Our Services', href: '#services' },
    { name: 'Contact Us', href: '#contact' },
  ],
  services: [
    { name: 'Civil Construction', href: '#services' },
    { name: 'Turnkey Projects', href: '#services' },
    { name: 'Project Management', href: '#services' },
    { name: 'Construction Consulting', href: '#services' },
  ],
  contact: [
    { name: 'info@insiteinfra.com', href: 'mailto:info@insiteinfra.com' },
    // { name: 'projects@insiteinfra.com', href: 'mailto:projects@insiteinfra.com' },
    { name: '+91 9447347731', href: 'tel:+919447347731' },
    { name: 'Calicut, Kerala, India', href: '#' },
  ],
};

// Social Media Links (icon type and href only - icons rendered in component)
export const socialLinksData = [
  // { name: 'Facebook', iconType: 'facebook', href: 'https://facebook.com' },
  { name: 'Instagram', iconType: 'instagram', href: 'https://www.instagram.com/insiteinfra_?igsh=MWJ0anNiYXdxYTFubA%3D%3D&utm_source=qr' },
  // { name: 'LinkedIn', iconType: 'linkedin', href: 'https://linkedin.com' },
  // { name: 'Twitter', iconType: 'twitter', href: 'https://twitter.com' },
];

// Footer Brand Info
export const footerBrand = {
  name: 'INSITE',
  subtitle: 'INFRASTRUCTURE',
  description: 'Creating innovative, sustainable, and timeless architectural spaces that inspire and elevate the human experience.',
};

// Legal Links
export const legalLinks = [
  { name: 'Privacy Policy', href: '#privacy' },
  { name: 'Terms of Service', href: '#terms' },
];

// Copyright
export const copyrightText = 'Insite Infrastructure. All rights reserved.';
